/* eslint-disable import/prefer-default-export */
import apiService from 'src/enviroment';
import { loaderService } from './loaderService';

const postSearch = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post(
      '/reportes/buscador/motomax/',
      params,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

export { postSearch };
